<template>
  <div class="auth-page">
    <div class="centred">
      <div class="auth-container has-text-centered">
        <h1>Permission Denied!</h1>
        <p>You do not have permission to access the requested page. If you believe you should have access then please contact the admin.</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'permission-denied',
    props: {
      firebaseUser: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="scss">
</style>
